import React, { useState, createContext } from "react";
// import { useParams } from 'react-router-dom';

const LeftMenuContext = createContext();

function LeftMenuContextProvider(props) {
  // const { local } = useParams();
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [catWithSubCat, setCatWithSubCat] = useState([]);
  const [priceFilter, setPriceFilter] = useState([0, 10000]);
  const [sliderMinMax, setSliderMinMax] = useState([0, 10000]);
  const [priceSort, setPriceSort] = useState("");
  const [country, setCountry] = useState("en-us");
  const [applyPriceFilter, setApplyPriceFilter] = useState(false);
  const [currentFilter, setCurrentFilter] = useState({
    type: "PAGE_VIEW",
    url: window.location.href,
    section: window.location.href,
  });

  const value = {
    category,
    subCategory,
    categories,

    setCategory,
    setSubCategory,
    setCategories,

    catWithSubCat,
    setCatWithSubCat,

    priceFilter,
    setPriceFilter,
    sliderMinMax,
    setSliderMinMax,
    priceSort,
    setPriceSort,

    country,
    setCountry,
    applyPriceFilter,
    setApplyPriceFilter,
    currentFilter,
    setCurrentFilter,
  };

  return (
    <LeftMenuContext.Provider value={value}>
      {props.children}
    </LeftMenuContext.Provider>
  );
}
const LeftMenuContextConsumer = LeftMenuContext.Consumer;

export { LeftMenuContext, LeftMenuContextProvider, LeftMenuContextConsumer };
export default LeftMenuContextProvider;
